import React from "react";

function Contact() {
    return (
        <div className="mt-10">
            <div className="container w-4/5">
                <h1 className="text-2xl font-semibold mb-4">Contact mama</h1>
                <p>For urgent matters, please call us or send us a message to </p>
                <p className="font-semibold">09777131313.</p>

                <p className="pt-2">As an e-commerce business, we will strive to cater to your inquires as fast as we can.</p>
                <p className="pt-2">Alternatively our contact details are: </p>

                <p className="pt-2 font-semibold">mama Myanmar</p>
                <p>198, B1, Ground Floor,</p>
                <p>50th Street, Upper Block,</p>
                <p>Pazundaung Township, </p>
                <p>Yangon, Myanmar</p>
            </div>
        </div>
    );
}

export default Contact;